import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'

import './index.css'

import { AppWrapper } from './AppWrapper'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<RouterProvider router={createBrowserRouter([{ path: '*', element: <AppWrapper /> }])} />)
